import { AsistenteTipo } from "src/app/config/config/models/asistente-tipo";

export class Asistente {
  public id: String;
  public descripcion: string;
  public nombre: string;
  public fechaCreacion: string;
  public fechaActualizacion: string;
  public usuarioAutualizador: string;
  public gafuAreaFuncional: string;
  public habilitado: boolean;
  public requiereAutenticacion: boolean;
  public tipo: string;
  public codigoAsistente: string;
  public formulario: any;
  public chatDTO: any;
  constructor(
    id: string,
    descripcion: string,
    nombre: string,
    fechaCreacion: string,
    fechaActualizacion: string,
    usuarioAutualizador: string,
    gafuAreaFuncional: string,
    habilitado: boolean,
    formulario: any,
    chat: any,
    codigoAsistente: string
  ) {
    this.id = id;
    this.descripcion = descripcion;
    this.nombre = nombre;
    this.fechaCreacion = fechaCreacion;
    this.fechaActualizacion = fechaActualizacion;
    this.usuarioAutualizador = usuarioAutualizador;
    this.gafuAreaFuncional = gafuAreaFuncional;
    this.habilitado = habilitado;
    this.formulario = formulario;
    this.chatDTO = chat;
    this.codigoAsistente = codigoAsistente;
  }

  definirTipo(): Asistente {

    if (this.chatDTO != null) {
      this.tipo = AsistenteTipo.Chat;
    } else if (this.formulario != null) {
      this.tipo = AsistenteTipo.Formulario;
    } else {
      this.tipo = AsistenteTipo.Menu;
    }
    return this;
  }
}

